import React, { Fragment, useEffect } from 'react'
import { useState } from 'react';
import styled from 'styled-components';
import { useGetComplaintsQuery } from '../../features/complaints/complaintsApiSlice';
import useAuth from '../../features/hooks/useAuth';
import UnivComplaintTable from './UnivComplaintTable';
import ComplaintDetails from './ComplaintDetails';
import { BackButtonSpan } from '../../Styles/CommonStyles';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

const Wrapper = styled.div``;

const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

// Updated column filter with new field names
const columnFilter = ["ComplaintNo", "assetId", "AssetName", "RegisteredBy", "Subject", "ComplaintCat", "ComplaintFilingTime", "Status", "Store", "ViewDetail"]

export default function AllComplaints() {
  const [viewDetail, setViewDetail] = useState(false);
  const [rowid, setRowid] = useState();
  const Auth = useAuth();

  // Get complaints data to find full complaint details by ID
  const { complaints } = useGetComplaintsQuery("complaints", {
    selectFromResult: ({ data }) => ({
      complaints: data?.entities
    }),
  });

  // Filter props for backend filtering based on user roles
  const getFilterProps = () => {
    if (Auth.supportuser) {
      if (Auth.roles.includes("Supervisor")) {
        return { perm_store: [Auth.store] };
      } else {
        return { perm_currentlyAssignedTo: [Auth.id] };
      }
    } else {
      const supportAdminOffices = Object.entries(Auth.roles || {})
        .filter(x => x[1].includes("supportadmin"))
        .map(elm => elm[0]);
      
      if (supportAdminOffices.length > 0) {
        return { perm_store: supportAdminOffices };
      }
    }
    return {};
  };

  const backClickedHandler = () => {
    setViewDetail(false)
  }

  const handleSubmit = () => {
    
  }

  return (
    <Container>
      <Wrapper>
        {!viewDetail ? 
          <UnivComplaintTable 
            columnFilter={columnFilter} 
            filterProps={getFilterProps()}
            setRowid={setRowid} 
            setViewDetail={setViewDetail}
            viewType="all"
          />
        :
          <> 
            <ComplaintDetails row={complaints[rowid]} subTabValue={6} setChangepage={() => setViewDetail(false)}/>                  
          </>
        }
      </Wrapper>
    </Container>
  );
}